import React from 'react';

const SvgExit = (props) => (
  <svg width={20} height={20} {...props}>
    <path
      fill="#FFF"
      d="M12.5 15h-5V3.752l-5-2.5h9.999V5h1.25V0H0v16.25L7.499 20v-3.75h6.25V10h-1.25v5h.001zM20 7.502l-5-3.75v2.5h-5v2.501h5v2.5l5-3.751h-.001z"
      opacity={0.5}
    />
  </svg>
);

export default SvgExit;
